import { Button } from "@/components/ui/button";

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

/**
 * Top-level error boundary fallback. Sentry's ErrorBoundary already
 * captured the error before this renders, so the user-facing job here
 * is just "tell them what happened, give them a way out."
 */
export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md text-center space-y-4">
        <h1 className="font-serif text-2xl font-bold text-foreground">
          Something went wrong
        </h1>
        <p className="text-sm text-muted-foreground">
          We've logged the error. Try again, or reload the page.
        </p>
        {import.meta.env.MODE !== "production" && (
          <pre className="text-xs text-left bg-muted p-3 rounded overflow-auto max-h-40">
            {error.message}
            {error.stack && (
              <>
                {"\n\n"}
                {error.stack}
              </>
            )}
          </pre>
        )}
        <div className="flex gap-2 justify-center">
          <Button onClick={resetError}>Try again</Button>
          <Button
            variant="outline"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
        </div>
      </div>
    </div>
  );
}
